import React from 'react';
import CreateTagStationModal from '../../../shared/component/tag/CreateTagStationModal';
import { useAdminVenueTag } from '../../share/hook/useAdminVenueTag';

interface CreateVenueTagModalProps {
  setIsUserInput: (isUserInput: boolean) => void;
}

const CreateVenueTagModal: React.FC<CreateVenueTagModalProps> = ({
  setIsUserInput,
}) => {
  const { createVenueTag } = useAdminVenueTag();

  return (
    <CreateTagStationModal
      createTag={createVenueTag}
      setIsUserInput={setIsUserInput}
    />
  );
};

export default CreateVenueTagModal;
